import { Injectable } from '@angular/core';

// Interfaces
import { JWTPayload } from '../interfaces/jwt-payload.interface';

// JWT Decode
import jwt_decode from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor() {}

  getToken(): string | null {
    const sessionToken = sessionStorage.getItem('token');
    if (sessionToken) {
      return sessionToken;
    }

    // Migracion de token legacy almacenado en localStorage.
    const legacyToken = localStorage.getItem('token');
    if (legacyToken) {
      sessionStorage.setItem('token', legacyToken);
      localStorage.removeItem('token');
    }

    return legacyToken;
  }

  setToken(token: string): void {
    sessionStorage.setItem('token', token);
    localStorage.removeItem('token');
  }

  clearToken(): void {
    sessionStorage.removeItem('token');
    localStorage.removeItem('token');
  }

  getPayload(token: string): JWTPayload {
    return jwt_decode(token);
  }

  isExpired(): boolean {
    const token = this.getToken();
    const now = Math.floor(Date.now() / 1000);

    if (!token) return true;

    const exp = JSON.parse(atob(token.split('.')[1])).exp;

    return exp <= now;
  }
}
